export default function HomeTemplate({ page, renderSections }) {
  return <div data-comp="HomeTemplate">{renderSections()}</div>;
}
